import { createContext } from "react";

import { initialAgenticAiState } from "./agenticAiState";
import type { AgenticAiContextType } from "./types";

export const initialAgenticAiContext: AgenticAiContextType = {
  ...initialAgenticAiState,
  openChat: () => {},
  closeChat: () => {},
  toggleOpenChat: () => {},
  sendUserPrompt: () => {},
  registerContext: () => () => {},
  registerAttachedFiles: () => () => {},
  getAttachedFiles: () => [],
  registerTool: () => () => {},
  registerSkill: () => () => {},
  loadSkill: () => {},
  getFrontendTool: () => undefined,
  getAllFrontendTools: () => [],
  getToolEntityIds: () => [],
  registerLiquidField: () => {},
  unregisterLiquidField: () => {},
  getAllLiquidFields: () => [],
  newSession: () => {},
  clearSupportEntryPoint: () => {},
  clearPendingExistingChatResponse: () => {},
  clearPendingBrandGuidelineContexts: () => {},
};

export const AgenticAiContext = createContext<AgenticAiContextType>(initialAgenticAiContext);
